import {MapRef} from '~types/Map';

import useMapLoadedEffect from './useMapLoadedEffect';

export default function useMapMaxPitch(map: MapRef, maxPitch: number = 40) {
    useMapLoadedEffect((loadedMap) => {
        loadedMap.setMaxPitch(maxPitch);
    }, map);
}
